import { store } from "../store/store";
import { resetCustomerInfo, resetOrderInfo } from "../store/transaction/transactionSlice";
import { resetVinForSearch } from "../store/VinsForSearch/VinsForSearchSlice";

export function resetInProgressState() {
    store.dispatch(resetCustomerInfo());
    store.dispatch(resetOrderInfo());
    store.dispatch(resetVinForSearch());
}